import {create} from 'zustand';
import {User} from 'firebase/auth';
import {getDebug} from '../library/GeneralUse';

type FirebaseAuthUserStore = {
	firebaseAuthUser: User | null;
	setFirebaseAuthUser: (newFirebaseAuthUser: User | null) => void;
};

const DEBUG = getDebug('auth');

export const useFirebaseAuthUserStore = create<FirebaseAuthUserStore>(
	(set) => ({
		firebaseAuthUser: null,
		setFirebaseAuthUser: (newFirebaseAuthUser: User | null) => {
			DEBUG &&
				console.trace(`setFirebaseAuthUser(`, newFirebaseAuthUser, `)`);
			set(() => ({firebaseAuthUser: newFirebaseAuthUser}));
		},
	}),
);
